import { render } from "./DamageStat.vue?vue&type=template&id=4bdb8be4"
import script from "./DamageStat.vue?vue&type=script&lang=js"
export * from "./DamageStat.vue?vue&type=script&lang=js"

import "./DamageStat.vue?vue&type=style&index=0&id=4bdb8be4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__